export const GET_PROMOTIONS_PAGE_DETAIL_START = `GET_PROMOTIONS_PAGE_DETAIL_START`;
export const GET_PROMOTIONS_PAGE_DETAIL_SUCCESS = `GET_PROMOTIONS_PAGE_DETAIL_SUCCESS`;
export const GET_PROMOTIONS_PAGE_DETAIL_ERROR = `GET_PROMOTIONS_PAGE_DETAIL_ERROR`;


export const GET_PROMOTIONS_PAGE_DETAIL_READMORE_START = `GET_PROMOTIONS_PAGE_DETAIL_READMORE_START`;
export const GET_PROMOTIONS_PAGE_DETAIL_READMORE_SUCCESS = `GET_PROMOTIONS_PAGE_DETAIL_READMORE_SUCCESS`;
export const GET_PROMOTIONS_PAGE_DETAIL_READMORE_ERROR = `GET_PROMOTIONS_PAGE_DETAIL_READMORE_ERROR`;